import script from "./DepositModal.vue?vue&type=script&setup=true&lang=js"
export * from "./DepositModal.vue?vue&type=script&setup=true&lang=js"

import "./DepositModal.vue?vue&type=style&index=0&id=10bf3076&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10bf3076"]])

export default __exports__